import React, { createContext, useContext, useEffect } from 'react';
import tiktokPixelService from '../services/tiktokPixelService';
import { useDropshipper } from './DropshipperContext';

const TikTokPixelContext = createContext(null);

export const useTikTokPixel = () => {
  const ctx = useContext(TikTokPixelContext);
  if (!ctx) {
    throw new Error('useTikTokPixel must be used inside <TikTokPixelProvider>');
  }
  return ctx;
};

export const TikTokPixelProvider = ({ children }) => {
  const { tiktokPixelId } = useDropshipper();

  useEffect(() => {
    if (tiktokPixelId) {
      tiktokPixelService.registerPixel(tiktokPixelId);
    }
  }, [tiktokPixelId]);

  const value = {
    pixelId: tiktokPixelId,
    isEnabled: !!tiktokPixelId,
    trackViewContent: (product) => tiktokPixelService.trackViewContent(tiktokPixelId, product),
    trackInitiateCheckout: (items, total) =>
      tiktokPixelService.trackInitiateCheckout(tiktokPixelId, items, total),
    trackPurchase: (orderData, eventId) =>
      tiktokPixelService.trackPurchase(tiktokPixelId, orderData, eventId),
  };

  return <TikTokPixelContext.Provider value={value}>{children}</TikTokPixelContext.Provider>;
};
